import React, { useEffect } from "react";
import "./MortalidadAvesTarjetas.css";
import { useShoppingContext } from "../../../../context/ShoppingContext";

const MortalidadAvesTarjetas = ({ porcentajeMortalidad }) => {
  const { fetchControlAves, controlAves, selectedAve } = useShoppingContext();

  useEffect(() => {
    if (selectedAve) {
      fetchControlAves(); // Aseguramos que los controles se carguen
    }
  }, [fetchControlAves, selectedAve]);

  // Filtrar los registros con muerte (death === true) y que pertenezcan al ave seleccionada
  const registrosConMuerte = controlAves.filter(
    (control) => control.death && control.ave_id === selectedAve?.id
  );

  // Calcular el número total de aves muertas y los motivos
  const totalAvesMuertas = registrosConMuerte.length;
  const motivosMuerte = registrosConMuerte.reduce((acc, control) => {
    const { motivo_muerte } = control;
    if (motivo_muerte) {
      acc[motivo_muerte] = (acc[motivo_muerte] || 0) + 1;
    }
    return acc;
  }, {});

  // Obtener los 3 principales motivos de muerte
  const motivosPrincipales = Object.entries(motivosMuerte)
    .sort(([, a], [, b]) => b - a)
    .slice(0, 3);

  return (
    <div className="mortalidad-aves-container">
      <div className="mortalidad-card">
        <div>
          <h3>Aves perdidas</h3>
          <div className=" avesPerdidas flex-space-between">
            <p className="mortalidad-value">{totalAvesMuertas}</p>
            <p>{porcentajeMortalidad}%</p>
          </div>
        </div>
        <h3>Principales Motivos</h3>
        <ul className="motivos-list">
          {motivosPrincipales.length > 0 ? (
            motivosPrincipales.map(([motivo, cantidad]) => (
              <li key={motivo}>
                {motivo}: {cantidad} casos
              </li>
            ))
          ) : (
            <li>No hay motivos registrados</li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default MortalidadAvesTarjetas;
